<ng-template #settingsTemplate>
    <app-tool-setting label="Tijd">
        <app-range-slider
            [max]="23"
            [range]="hoursModel"
            label="Uren"
            (rangeChange)="rangeChange($event, timeSegmentEnum.Hours)"
        ></app-range-slider>
        <app-range-slider
            [max]="59"
            [range]="minutesModel"
            label="Minuten"
            (rangeChange)="rangeChange($event, timeSegmentEnum.Minutes)"
        ></app-range-slider>
    </app-tool-setting>
    <app-tool-setting>
        <div class="seconds">
            <app-check-box [(checked)]="showSeconds"></app-check-box>
            <app-range-slider
                [max]="59"
                [range]="secondsModel"
                label="Seconden"
                [disabled]="!showSeconds"
                (rangeChange)="rangeChange($event, timeSegmentEnum.Seconds)"
            ></app-range-slider>
        </div>
    </app-tool-setting>
    <app-tool-setting label="Vergroten">
        <app-radio-input
            [value]="'default'"
            [model]="zoomSize"
            (selected)="setZoomSize('default')"
            >Standaard</app-radio-input
        >
        <app-radio-input
            [value]="'medium'"
            [model]="zoomSize"
            (selected)="setZoomSize('medium')"
            >Groter</app-radio-input
        >
        <app-radio-input
            [value]="'large'"
            [model]="zoomSize"
            (selected)="setZoomSize('large')"
            >Grootst</app-radio-input
        >
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        version="1.1"
        class="svg"
        [ngClass]="'svg--' + zoomSize"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        [attr.viewBox]="'0 0 ' + (showSeconds ? '2616' : '1789') + ' 766.9'"
        [attr.style]="
            'enable-background:new 0 0 ' +
            (showSeconds ? '2616' : '1789') +
            ' 766.9;'
        "
        xml:space="preserve"
    >
        <style type="text/css">
            .stDigitalClock0 {
                fill: url(#SVGID_1_);
                stroke: #008ec8;
            }

            .stDigitalClock1 {
                fill: #ffffff;
                stroke: #008ec8;
                stroke-width: 0.1758;
            }

            .stDigitalClock2 {
                fill: #ffffff;
                stroke: #008ec8;
                stroke-width: 0.1757;
            }

            .hidden {
                display: none;
            }
        </style>
        <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="1308.019"
            y1="1.644"
            x2="1308.019"
            y2="767.5"
            gradientTransform="matrix(1 0 0 -1 0 768)"
        >
            <stop offset="5.500000e-03" style="stop-color: #008ec8" />
            <stop offset="0.5" style="stop-color: #008ec8" />
            <stop offset="1" style="stop-color: #008ec8" />
        </linearGradient>
        @if (showSeconds) {
        <path
            xmlns="http://www.w3.org/2000/svg"
            class="stDigitalClock0"
            d="M2358.2-0.2H1081.8c-6,0-11.9,0.2-17.8,0.6H258.3C117.3,0.4,3,114.7,3,255.7V511c0,141,114.3,255.3,255.3,255.3  h1276.4c6,0,11.9-0.2,17.8-0.6h805.7c141,0,255.3-114.3,255.3-255.3V255.1C2613.5,114.1,2499.2-0.2,2358.2-0.2z"
        />
        } @if (!showSeconds) {
        <path
            xmlns="http://www.w3.org/2000/svg"
            style="fill: url(#SVGID_1_); stroke: #008ec8"
            d="M1787.5,511.071c0,141.012-114.291,255.285-255.285,255.285H255.785  C114.789,766.356,0.5,652.083,0.5,511.071V255.785C0.5,114.773,114.789,0.5,255.785,0.5h1276.43  c140.994,0,255.285,114.273,255.285,255.285V511.071z"
        />
        }

        <g class="hours">
            <g class="hours1">
                @if (clock.hoursSegments.segmentZero.indexOf('a') !== -1) {
                <polygon
                    class="stDigitalClock1 a"
                    points="206.4,375.7 181.8,351.7 181.8,199.2 206.4,175.9 233.5,201.1 233.5,351.1 "
                />
                } @if (clock.hoursSegments.segmentZero.indexOf('b') !== -1) {
                <polygon
                    class="stDigitalClock1 b"
                    points="206.4,598.2 181.8,574.9 181.8,423.6 206.4,399.6 233.5,424.8 233.5,573.6 "
                />
                } @if (clock.hoursSegments.segmentZero.indexOf('c') !== -1) {
                <polygon
                    class="stDigitalClock1 c"
                    points="413.1,187.8 239.8,187.8 215.9,163.3 240.4,136.8 412.5,136.8 437.7,162.6 "
                />
                } @if (clock.hoursSegments.segmentZero.indexOf('d') !== -1) {
                <polygon
                    class="stDigitalClock1 d"
                    points="413.1,413.5 239.8,413.5 215.9,388.9 241.1,361.8 413.1,361.8 437.7,388.3 "
                />
                } @if (clock.hoursSegments.segmentZero.indexOf('e') !== -1) {
                <polygon
                    class="stDigitalClock1 e"
                    points="413.1,637.9 241.1,637.9 215.9,611.4 239.8,586.2 413.1,586.2 437.7,611.4 "
                />
                } @if (clock.hoursSegments.segmentZero.indexOf('f') !== -1) {
                <polygon
                    class="stDigitalClock1 f"
                    points="447.8,375.7 423.2,351.7 423.2,199.2 447.8,175.9 474.9,201.1 474.9,351.1 "
                />
                } @if (clock.hoursSegments.segmentZero.indexOf('g') !== -1) {
                <polygon
                    class="stDigitalClock1 g"
                    points="447.8,598.2 423.2,574.9 423.2,423.6 447.8,399.6 474.9,424.8 474.9,573.6 "
                />
                }
            </g>
            <g class="hours2">
                @if (clock.hoursSegments.segmentOne.indexOf('a') !== -1) {
                <polygon
                    class="stDigitalClock1 a"
                    points="556.4,373.7 531.8,349.7 531.8,197.2 556.4,173.9 583.5,199.1 583.5,349.1 "
                />
                } @if (clock.hoursSegments.segmentOne.indexOf('b') !== -1) {
                <polygon
                    class="stDigitalClock1 b"
                    points="556.4,596.2 531.8,572.9 531.8,421.6 556.4,397.6 583.5,422.8 583.5,571.6 "
                />
                } @if (clock.hoursSegments.segmentOne.indexOf('c') !== -1) {
                <polygon
                    class="stDigitalClock1 c"
                    points="763.1,185.8 589.8,185.8 565.9,161.3 590.4,134.8 762.5,134.8 787.7,160.6 "
                />
                } @if (clock.hoursSegments.segmentOne.indexOf('d') !== -1) {
                <polygon
                    class="stDigitalClock1 d"
                    points="763.1,411.5 589.8,411.5 565.9,386.9 591.1,359.8 763.1,359.8 787.7,386.3 "
                />
                } @if (clock.hoursSegments.segmentOne.indexOf('e') !== -1) {
                <polygon
                    class="stDigitalClock1 e"
                    points="763.1,635.9 591.1,635.9 565.9,609.4 589.8,584.2 763.1,584.2 787.7,609.4 "
                />
                } @if (clock.hoursSegments.segmentOne.indexOf('f') !== -1) {
                <polygon
                    class="stDigitalClock1 f"
                    points="797.8,373.7 773.2,349.7 773.2,197.2 797.8,173.9 824.9,199.1 824.9,349.1 "
                />
                } @if (clock.hoursSegments.segmentOne.indexOf('g') !== -1) {
                <polygon
                    class="stDigitalClock1 g"
                    points="797.8,596.2 773.2,572.9 773.2,421.6 797.8,397.6 824.9,422.8 824.9,571.6 "
                />
                }
            </g>
        </g>
        <g class="dots">
            <g>
                <path
                    class="stDigitalClock2"
                    d="M894.3,511.1l-34.7-35.9l34.7-34.7l35.3,34.7L894.3,511.1z"
                />
            </g>
            <g>
                <path
                    class="stDigitalClock2"
                    d="M901.3,336.5l-34.7-35.9l34.7-34.7l35.3,34.7L901.3,336.5z"
                />
            </g>
        </g>
        <g class="minutes">
            <g class="minutes1">
                @if (clock.minutesSegments.segmentZero.indexOf('a') !== -1) {
                <polygon
                    class="stDigitalClock1 a"
                    points="1000.4,377.7 975.8,353.7 975.8,201.2 1000.4,177.9 1027.5,203.1 1027.5,353.1 "
                />
                } @if (clock.minutesSegments.segmentZero.indexOf('b') !== -1) {
                <polygon
                    class="stDigitalClock1 b"
                    points="1000.4,600.2 975.8,576.9 975.8,425.6 1000.4,401.6 1027.5,426.8 1027.5,575.6 "
                />
                } @if (clock.minutesSegments.segmentZero.indexOf('c') !== -1) {
                <polygon
                    class="stDigitalClock1 c"
                    points="1207.1,189.8 1033.8,189.8 1009.9,165.3 1034.4,138.8 1206.5,138.8 1231.7,164.6 "
                />
                } @if (clock.minutesSegments.segmentZero.indexOf('d') !== -1) {
                <polygon
                    class="stDigitalClock1 d"
                    points="1207.1,415.5 1033.8,415.5 1009.9,390.9 1035.1,363.8 1207.1,363.8 1231.7,390.3 "
                />
                } @if (clock.minutesSegments.segmentZero.indexOf('e') !== -1) {
                <polygon
                    class="stDigitalClock1 e"
                    points="1207.1,639.9 1035.1,639.9 1009.9,613.4 1033.8,588.2 1207.1,588.2 1231.7,613.4 "
                />
                } @if (clock.minutesSegments.segmentZero.indexOf('f') !== -1) {
                <polygon
                    class="stDigitalClock1 f"
                    points="1241.8,377.7 1217.2,353.7 1217.2,201.2 1241.8,177.9 1268.9,203.1 1268.9,353.1 "
                />
                } @if (clock.minutesSegments.segmentZero.indexOf('g') !== -1) {
                <polygon
                    class="stDigitalClock1 g"
                    points="1241.8,600.2 1217.2,576.9 1217.2,425.6 1241.8,401.6 1268.9,426.8 1268.9,575.6 "
                />
                }
            </g>
            <g class="minutes2">
                @if (clock.minutesSegments.segmentOne.indexOf('a') !== -1) {
                <polygon
                    class="stDigitalClock1 a"
                    points="1350.4,375.7 1325.8,351.7 1325.8,199.2 1350.4,175.9 1377.5,201.1 1377.5,351.1 "
                />
                } @if (clock.minutesSegments.segmentOne.indexOf('b') !== -1) {
                <polygon
                    class="stDigitalClock1 b"
                    points="1350.4,598.2 1325.8,574.9 1325.8,423.6 1350.4,399.6 1377.5,424.8 1377.5,573.6 "
                />
                } @if (clock.minutesSegments.segmentOne.indexOf('c') !== -1) {
                <polygon
                    class="stDigitalClock1 c"
                    points="1557.1,187.8 1383.8,187.8 1359.9,163.3 1384.4,136.8 1556.5,136.8 1581.7,162.6 "
                />
                } @if (clock.minutesSegments.segmentOne.indexOf('d') !== -1) {
                <polygon
                    class="stDigitalClock1 d"
                    points="1557.1,413.5 1383.8,413.5 1359.9,388.9 1385.1,361.8 1557.1,361.8 1581.7,388.3 "
                />
                } @if (clock.minutesSegments.segmentOne.indexOf('e') !== -1) {
                <polygon
                    class="stDigitalClock1 e"
                    points="1557.1,637.9 1385.1,637.9 1359.9,611.4 1383.8,586.2 1557.1,586.2 1581.7,611.4 "
                />
                } @if (clock.minutesSegments.segmentOne.indexOf('f') !== -1) {
                <polygon
                    class="stDigitalClock1 f"
                    points="1591.8,375.7 1567.2,351.7 1567.2,199.2 1591.8,175.9 1618.9,201.1 1618.9,351.1 "
                />
                } @if (clock.minutesSegments.segmentOne.indexOf('g') !== -1) {
                <polygon
                    class="stDigitalClock1 g"
                    points="1591.8,598.2 1567.2,574.9 1567.2,423.6 1591.8,399.6 1618.9,424.8 1618.9,573.6 "
                />
                }
            </g>
        </g>
        @if (showSeconds) {
        <g class="dots">
            <g>
                <path
                    class="stDigitalClock2"
                    d="M1702.7,509.7l-34.7-35.9l34.7-34.7l35.3,34.7L1702.7,509.7z"
                />
            </g>
            <g>
                <path
                    class="stDigitalClock2"
                    d="M1709.6,335.1l-34.7-35.9l34.7-34.7l35.3,34.7L1709.6,335.1z"
                />
            </g>
        </g>
        } @if (showSeconds) {
        <g class="seconds">
            <g class="seconds1">
                @if (clock.secondsSegments.segmentZero.indexOf('a') !== -1) {
                <polygon
                    class="stDigitalClock1 a"
                    points="1808.8,376.3 1784.2,352.3 1784.2,199.8 1808.8,176.5 1835.9,201.7 1835.9,351.7 "
                />
                } @if (clock.secondsSegments.segmentZero.indexOf('b') !== -1) {
                <polygon
                    class="stDigitalClock1 b"
                    points="1808.8,598.8 1784.2,575.5 1784.2,424.2 1808.8,400.2 1835.9,425.4 1835.9,574.2 "
                />
                } @if (clock.secondsSegments.segmentZero.indexOf('c') !== -1) {
                <polygon
                    class="stDigitalClock1 c"
                    points="2015.5,188.4 1842.2,188.4 1818.3,163.9 1842.8,137.4 2014.9,137.4 2040.1,163.2 "
                />
                } @if (clock.secondsSegments.segmentZero.indexOf('d') !== -1) {
                <polygon
                    class="stDigitalClock1 d"
                    points="2015.5,414.1 1842.2,414.1 1818.3,389.5 1843.5,362.4 2015.5,362.4 2040.1,388.9 "
                />
                } @if (clock.secondsSegments.segmentZero.indexOf('e') !== -1) {
                <polygon
                    class="stDigitalClock1 e"
                    points="2015.5,638.5 1843.5,638.5 1818.3,612 1842.2,586.8 2015.5,586.8 2040.1,612 "
                />
                } @if (clock.secondsSegments.segmentZero.indexOf('f') !== -1) {
                <polygon
                    class="stDigitalClock1 f"
                    points="2050.2,376.3 2025.6,352.3 2025.6,199.8 2050.2,176.5 2077.3,201.7 2077.3,351.7 "
                />
                } @if (clock.secondsSegments.segmentZero.indexOf('g') !== -1) {
                <polygon
                    class="stDigitalClock1 g"
                    points="2050.2,598.8 2025.6,575.5 2025.6,424.2 2050.2,400.2 2077.3,425.4 2077.3,574.2 "
                />
                }
            </g>
            <g class="seconds2">
                @if (clock.secondsSegments.segmentOne.indexOf('a') !== -1) {
                <polygon
                    class="stDigitalClock1 a"
                    points="2158.8,374.3 2134.2,350.3 2134.2,197.8 2158.8,174.5 2185.9,199.7 2185.9,349.7 "
                />
                } @if (clock.secondsSegments.segmentOne.indexOf('b') !== -1) {
                <polygon
                    class="stDigitalClock1 b"
                    points="2158.8,596.8 2134.2,573.5 2134.2,422.2 2158.8,398.2 2185.9,423.4 2185.9,572.2 "
                />
                } @if (clock.secondsSegments.segmentOne.indexOf('c') !== -1) {
                <polygon
                    class="stDigitalClock1 c"
                    points="2365.5,186.4 2192.2,186.4 2168.3,161.9 2192.8,135.4 2364.9,135.4 2390.1,161.2 "
                />
                } @if (clock.secondsSegments.segmentOne.indexOf('d') !== -1) {
                <polygon
                    class="stDigitalClock1 d"
                    points="2365.5,412.1 2192.2,412.1 2168.3,387.5 2193.5,360.4 2365.5,360.4 2390.1,386.9 "
                />
                } @if (clock.secondsSegments.segmentOne.indexOf('e') !== -1) {
                <polygon
                    class="stDigitalClock1 e"
                    points="2365.5,636.5 2193.5,636.5 2168.3,610 2192.2,584.8 2365.5,584.8 2390.1,610 "
                />
                } @if (clock.secondsSegments.segmentOne.indexOf('f') !== -1) {
                <polygon
                    class="stDigitalClock1 f"
                    points="2400.2,374.3 2375.6,350.3 2375.6,197.8 2400.2,174.5 2427.3,199.7 2427.3,349.7 "
                />
                } @if (clock.secondsSegments.segmentOne.indexOf('g') !== -1) {
                <polygon
                    class="stDigitalClock1 g"
                    points="2400.2,596.8 2375.6,573.5 2375.6,422.2 2400.2,398.2 2427.3,423.4 2427.3,572.2 "
                />
                }
            </g>
        </g>
        }
    </svg>
</ng-template>
